// @ts-nocheck
// ====== Quick switcher (Ctrl/Cmd+K) ======
// Palette flottante per saltare rapidamente a un cliente, una risorsa o
// una vista. Si apre con Ctrl/Cmd+K (o "/"), naviga con frecce,
// Enter apre la selezione, Esc chiude.
//
// Sorgenti di dati:
//   - state.clients  -> apre modal cliente
//   - state.resources -> apre vista risorsa-detail
//   - elenco viste statico (admin only filtrate)

const VIEWS = [
  { id: 'dashboard', label: 'Dashboard', hint: 'Panoramica', admin: false },
  { id: 'clienti', label: 'Clienti', hint: 'Anagrafica', admin: false },
  { id: 'risorse', label: 'Risorse', hint: 'Team Ma.Se.', admin: false },
  { id: 'pm', label: 'Riferimenti interni', hint: 'CPL / PM', admin: false },
  { id: 'azioni', label: 'Azioni aperte', hint: 'Utenze da gestire', admin: true },
  { id: 'scadenze', label: 'Scadenze', hint: 'Contratti, rinnovi', admin: true },
  { id: 'storico', label: 'Storico', hint: 'Audit log', admin: true },
  { id: 'ruoli', label: 'Catalogo ruoli', hint: 'Ruoli predefiniti', admin: true },
  { id: 'sicurezza', label: 'Sicurezza', hint: 'Utenti, backup', admin: true },
  { id: 'impostazioni', label: 'Impostazioni', hint: 'Profilo, legenda', admin: false }
];

let _qsOpen = false;
let _qsIndex = 0;
let _qsResults = [];

function buildSources() {
  const admin = typeof isAdmin === 'function' && isAdmin();
  const views = VIEWS.filter((v) => !v.admin || admin).map((v) => ({
    kind: 'view',
    id: v.id,
    label: v.label,
    hint: v.hint,
    icon: 'view'
  }));
  const clients = (state?.clients || []).map((c) => ({
    kind: 'client',
    id: c.nome,
    label: c.nome,
    hint: [c.cpl, (c.perimetri || []).join(' · ')].filter(Boolean).join(' — '),
    icon: 'client'
  }));
  const resources = (state?.resources || []).map((r) => ({
    kind: 'resource',
    id: r,
    label: r,
    hint: 'Risorsa Ma.Se.',
    icon: 'resource'
  }));
  const all = [...views, ...clients, ...resources];
  // F8: lascia ai moduli estendere la lista (es. quick-switcher-actions.js)
  globalThis.bus?.emit('qs:build', all);
  return all;
}

function highlight(text, query) {
  if (!query) return escapeHtml(text);
  const q = query.trim().toLowerCase();
  const t = String(text);
  const lower = t.toLowerCase();
  let out = '';
  let i = 0;
  while (i < t.length) {
    const hit = lower.indexOf(q, i);
    if (hit === -1) {
      out += escapeHtml(t.slice(i));
      break;
    }
    out += escapeHtml(t.slice(i, hit));
    out += '<mark>' + escapeHtml(t.slice(hit, hit + q.length)) + '</mark>';
    i = hit + q.length;
  }
  return out;
}

function scoreItem(item, q) {
  if (!q) return 0;
  const label = item.label.toLowerCase();
  const hint = (item.hint || '').toLowerCase();
  if (label === q) return 100;
  if (label.startsWith(q)) return 80;
  if (label.includes(q)) return 60;
  if (hint.includes(q)) return 40;
  return -1;
}

function renderResults() {
  const list = document.getElementById('qsList');
  const input = /** @type {HTMLInputElement} */ (document.getElementById('qsInput'));
  if (!list || !input) return;
  const q = input.value.toLowerCase().trim();
  const all = buildSources();
  if (!q) {
    _qsResults = all.slice(0, 8);
  } else {
    _qsResults = all
      .map((it) => ({ it, score: scoreItem(it, q) }))
      .filter((x) => x.score >= 0)
      .sort((a, b) => b.score - a.score)
      .slice(0, 25)
      .map((x) => x.it);
  }
  if (_qsIndex >= _qsResults.length) _qsIndex = 0;
  if (!_qsResults.length) {
    list.innerHTML = '<div class="qs-empty">Nessun risultato</div>';
    return;
  }
  const kindLabel = (k) =>
    k === 'client' ? 'Cliente' : k === 'resource' ? 'Risorsa' : k === 'action' ? 'Azione' : 'Vista';
  list.innerHTML = _qsResults
    .map(
      (it, i) => `
      <button type="button" class="qs-item ${i === _qsIndex ? 'active' : ''}" data-i="${i}">
        <span class="qs-icon qs-icon-${it.icon}" aria-hidden="true"></span>
        <span class="qs-label">${highlight(it.label, q)}</span>
        <span class="qs-hint">${highlight(it.hint || '', q)}</span>
        <span class="qs-kind">${kindLabel(it.kind)}</span>
      </button>`
    )
    .join('');
  list.querySelectorAll('.qs-item').forEach((btn) => {
    btn.addEventListener('mouseenter', () => {
      _qsIndex = parseInt(btn.dataset.i, 10);
      updateActive();
    });
    btn.addEventListener('click', () => {
      _qsIndex = parseInt(btn.dataset.i, 10);
      activateCurrent();
    });
  });
}

function updateActive() {
  document.querySelectorAll('#qsList .qs-item').forEach((el, i) => {
    el.classList.toggle('active', i === _qsIndex);
  });
  const active = document.querySelector('#qsList .qs-item.active');
  if (active && active.scrollIntoView) {
    active.scrollIntoView({ block: 'nearest' });
  }
}

function activateCurrent() {
  const it = _qsResults[_qsIndex];
  if (!it) return;
  closeQuickSwitcher();
  if (it.kind === 'view') {
    if (typeof setView === 'function') setView(it.id);
  } else if (it.kind === 'client') {
    if (typeof openModal === 'function') openModal(it.id);
    else if (typeof setView === 'function') setView('clienti');
  } else if (it.kind === 'resource') {
    globalThis.currentRisorsaDetail = it.id;
    if (typeof setView === 'function') setView('risorsa-detail');
  } else if (it.kind === 'action' && typeof it._run === 'function') {
    // F8: azioni estese
    try {
      it._run();
    } catch (e) {
      console.error('[qs] action error', e);
    }
  }
}

function openQuickSwitcher() {
  if (_qsOpen) return;
  _qsOpen = true;
  _qsIndex = 0;
  const root = ensureSwitcherDom();
  root.classList.remove('hidden');
  const input = /** @type {HTMLInputElement} */ (document.getElementById('qsInput'));
  if (input) {
    input.value = '';
    setTimeout(() => input.focus(), 30);
  }
  renderResults();
}

function closeQuickSwitcher() {
  if (!_qsOpen) return;
  _qsOpen = false;
  const root = document.getElementById('quickSwitcher');
  if (root) root.classList.add('hidden');
}

function ensureSwitcherDom() {
  let root = document.getElementById('quickSwitcher');
  if (root) return root;
  root = document.createElement('div');
  root.id = 'quickSwitcher';
  root.className = 'qs-overlay hidden';
  root.setAttribute('role', 'dialog');
  root.setAttribute('aria-modal', 'true');
  root.setAttribute('aria-label', 'Quick switcher');
  root.innerHTML = `
    <div class="qs-backdrop" data-qs-close></div>
    <div class="qs-panel">
      <div class="qs-input-wrap">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="11" cy="11" r="8"/>
          <line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
        <input type="text" id="qsInput" placeholder="Cerca cliente, risorsa o vista…"
               autocomplete="off" spellcheck="false" aria-label="Quick switcher: cerca">
        <kbd class="qs-kbd">Esc</kbd>
      </div>
      <div id="qsList" class="qs-list" role="listbox" aria-label="Risultati"></div>
      <div class="qs-foot">
        <span><kbd>↑</kbd><kbd>↓</kbd> per muoverti</span>
        <span><kbd>Enter</kbd> per aprire</span>
        <span><kbd>Esc</kbd> per chiudere</span>
      </div>
    </div>`;
  document.body.appendChild(root);

  root.querySelector('[data-qs-close]').addEventListener('click', closeQuickSwitcher);
  const input = /** @type {HTMLInputElement} */ (document.getElementById('qsInput'));
  input.addEventListener('input', () => renderResults());
  input.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      _qsIndex = Math.min(_qsResults.length - 1, _qsIndex + 1);
      updateActive();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      _qsIndex = Math.max(0, _qsIndex - 1);
      updateActive();
    } else if (e.key === 'Enter') {
      e.preventDefault();
      activateCurrent();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      closeQuickSwitcher();
    }
  });

  return root;
}

// Scorciatoia globale
document.addEventListener('keydown', (e) => {
  const tag = (document.activeElement?.tagName || '').toLowerCase();
  const inField = tag === 'input' || tag === 'textarea' || tag === 'select';

  // Ctrl/Cmd+K apre sempre
  if ((e.ctrlKey || e.metaKey) && (e.key === 'k' || e.key === 'K')) {
    e.preventDefault();
    if (_qsOpen) closeQuickSwitcher();
    else openQuickSwitcher();
    return;
  }
  // "/" apre solo se non sei già dentro a un campo
  if (e.key === '/' && !inField && !_qsOpen) {
    e.preventDefault();
    openQuickSwitcher();
  }
});

// Bottone topbar (chip ⌘K) — agganciato al DOMContentLoaded
function wireTopbarTrigger() {
  const btn = document.getElementById('btnOpenQuickSwitcher');
  if (btn) btn.addEventListener('click', openQuickSwitcher);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', wireTopbarTrigger);
} else {
  wireTopbarTrigger();
}

Object.assign(globalThis, { openQuickSwitcher, closeQuickSwitcher });
export {};
